import { withSpacing } from "hoc-lib/spacing"
import withSSRModel from "hoc-lib/ssrModelMapper"
import ValueProposition from "./ValueProposition"

const WrappedComponent = withSSRModel(
  withSpacing({
    forceComponentBackgroundColor: true,
    useTopSpacing: true,
  })(ValueProposition),
)

// Component has to be mapped by the consumer
// Config has to be imported from constants-lib and passed to the MapTo function by the consumer
export default WrappedComponent
